import React from 'react';
import SearchComponent from './SearchComponent';
import Navbar from './Navbar';
import MobileQuickMenu from './MobileQuickMenu';
import HeroBackground from '../assets/NYD-banner-header-1440x560.jpg';

function Header({ destaques = [] }) {
  return (
    <header className="relative text-white text-center">
      <Navbar />

      {/* Desktop: proporción real de la imagen (1440x560). Mobile: más alto para alojar navbar + accesos sobre la imagen */}
      <div className="relative w-full h-[340px] md:h-auto md:aspect-[1440/560] overflow-hidden">
        <img
          src={HeroBackground}
          alt="Hero Background"
          className="absolute inset-0 w-full h-full object-cover object-right md:object-center"
          loading="eager"
          fetchpriority="high"
        />
        {/* Mobile: accesos rápidos sobre la imagen (debajo del navbar) */}
        <div className="absolute inset-x-0 top-[88px] md:hidden">
          <MobileQuickMenu destaques={destaques} />
        </div>
        {/* Mobile: titular real (el de la imagen se recorta en pantallas angostas) */}
        <p className="absolute left-5 right-5 top-[212px] md:hidden text-left text-[22px] leading-[1.15] font-semibold tracking-tight [text-shadow:0_1px_12px_rgba(0,0,0,0.45)]">
          Viajá, disfrutá y viví<br />una vida llena de aventuras
        </p>
      </div>
      
      {/* Buscador - En mobile más pegado a la imagen */}
      <div className="relative -mt-12 md:-mt-24 lg:-mt-20 z-20 container mx-auto px-3 md:px-4">
        <div className="shadow-[0_10px_40px_rgba(0,0,0,0.6)] rounded-3xl">
          <SearchComponent />
        </div>
      </div>
    </header>
  );
}

export default Header;